import { useContext, useCallback } from 'react';

import PodContext from './PodContext';
import { ALL_CLIENTS } from './constants';

const usePodFilter = () => {
  const { users: podUsers, selectedPodId } = useContext(PodContext);

  const getFilteredDocs = useCallback((docs, key) => {
    if (!selectedPodId || selectedPodId === ALL_CLIENTS) return docs;

    if (!Array.isArray(podUsers) || podUsers.length === 0) return [];

    return docs.filter((doc) => podUsers.includes(doc[key]));
  }, [podUsers, selectedPodId]);

  return getFilteredDocs;
};

export { usePodFilter };
